import styled from 'styled-components';
import { HudIcon } from '@hud/web-components/Icons/HudIcons';
import Menu from '@hud/web-components/Menu/Menu';

import MenuButton from '@hud/web-components/Menu/MenuButton';
import { themeColor } from '@hud/web-components/theme/colors';

export const Button = styled(MenuButton)`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px;
`;

export const Icon = styled(HudIcon)`
  color: ${themeColor('gray')};
`;

export const Item = styled(Menu.Item)`
  & .mantine-Menu-itemLabel {
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;
  }
`;
